import { on } from '@/modules/job-queue/event-bus'
import { registerDefaultJobHandlers } from '@/modules/job-queue/handlers'
import { processAllJobs } from '@/modules/job-queue/queue'
import { type ReactNode, useEffect } from 'react'

interface JobQueueProviderProps {
  children: ReactNode
}

export function JobQueueProvider({ children }: JobQueueProviderProps) {
  useEffect(() => {
    registerDefaultJobHandlers()
    void processAllJobs()

    const disposeQueued = on('job:queued', () => {
      void processAllJobs()
    })
    const disposeRetry = on('job:retry', () => {
      void processAllJobs()
    })
    const interval = window.setInterval(() => {
      void processAllJobs()
    }, 2_000)

    return () => {
      disposeQueued()
      disposeRetry()
      window.clearInterval(interval)
    }
  }, [])

  return <>{children}</>
}
